import { BillingInterval } from "@flowstepdesign/shared";
import clsx from "clsx";

import { Badge } from "./ui/badge";

interface BillingToggleProps {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
  dataAttributes?: {
    variant?: string;
    experiment?: string;
  };
}

export function BillingToggle({
  value,
  onChange,
  dataAttributes,
}: BillingToggleProps) {
  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-full border border-[#0247FE]/10 bg-gradient-to-r from-[#0247FE]/5 to-[#06B6D4]/5 p-1 shadow-sm"
      data-event="Billing Toggle Interacted"
      data-variant={dataAttributes?.variant}
      data-experiment={dataAttributes?.experiment}
    >
      <button
        onClick={() => onChange("month")}
        className={clsx(
          "rounded-full px-4 py-1.5 text-sm transition-all duration-300",
          value === "month"
            ? "text-foreground bg-white shadow-sm"
            : "text-muted-foreground hover:text-foreground hover:bg-white/50",
        )}
      >
        Monthly
      </button>
      <button
        onClick={() => onChange("year")}
        className={clsx(
          "flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm transition-all duration-300",
          value === "year"
            ? "scale-105 bg-gradient-to-r from-[#0247FE] to-[#0247FE]/90 text-white shadow-md shadow-[#0247FE]/20"
            : "text-muted-foreground hover:text-foreground hover:bg-white/50",
        )}
      >
        Annual
        {value === "year" && (
          <Badge className="border-0 bg-white/20 px-1.5 py-0 text-[10px] text-white">
            Save 20%
          </Badge>
        )}
      </button>
    </div>
  );
}
